import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { EmailVerificationForm } from 'src/Components/Forms/EmailVerificationForm';
import { EmailVerifiedForm } from 'src/Components/Forms/EmailVerifiedForm';
import { PleaseConfirmEmail } from 'src/Containers/Auth/EmailVerificationPage/PleaseConfirmEmail';
import { ContentOverlay } from 'src/Containers/ContentOverlay';

const EmailVerificationPage = () => {
  const [verified, setVerified] = useState(false);
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  if (token)
    return (
      <ContentOverlay>
        {!verified && <EmailVerificationForm acknowledgeVerify={() => setVerified(true)} />}
        {verified && <EmailVerifiedForm />}
      </ContentOverlay>
    );

  return <PleaseConfirmEmail />;
};

export default EmailVerificationPage;
